import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const DomainNotConnectedErrorTooltip = ({
  children
}) => /*#__PURE__*/_jsx(Tooltip, {
  placement: "bottom left",
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "knowledgeContentUI.shared.domainNotConnectedError"
  }),
  zIndex: 1211,
  children: children
});
DomainNotConnectedErrorTooltip.propTypes = {
  children: PropTypes.element.isRequired
};
export default DomainNotConnectedErrorTooltip;